<template>
  <div id="app" class="container mx-auto">
<div v-show="loading" class="fixed top-0 left-0 insert-0 bg-gray-900 bg-opacity-90 overflow-y-auto h-full w-full z-50 text-white text-center">
  <div class="flex justify-center items-center h-full">
    <div class="text-3xl loader">
      Loading
      </div> 

  </div>
</div>


<!---Modal -->
<div :key="componentKey" class="fixed top-0 left-0 insert-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50" :class="showModal ? 'block':'hidden'">
  <div class="relative mx-auto border md:mt-20 mt-0 md:w-3/4 md:h-3/4 w-full h-full md:shadow-lg md:rounded-md bg-white transition-opacity ease-in duration-700 opacity-100">

    <div class="bg-gray-600 text-white p-2 ">
      {{modal.title}}
    </div>
    <div class=" overflow-y-auto" style="height:590px;">

    <vue-select-image v-if="ismultiple"
          :dataImages="modal.dataset"
          :is-multiple="true"
          :selectedImages="prompts.data"
          @onselectimage="onSelectImage"
          @onselectmultipleimage="onSelectMultipleImage"
          :useLabel="false"
        >
    </vue-select-image>

    </div>          
    <div class="flex md:flex-row flex-col justify-end bg-gray-200 absolute bottom-0 left-0 w-full">
      <div class="p-3 ">
        <button class="p-2 rounded bg-red-400 hover:bg-red-500 text-white md:mr-2 md:w-36 w-1/2" @click="clearModal()">Clear </button>
        <button class="p-2 rounded bg-green-400 hover:bg-green-500 text-white md:w-36 w-1/2 shadow" @click="hideModal()">Ok</button>
      </div>   
    </div>
  </div>
</div>


  <div class="mx-auto  container">
    <div class="mx-2" >
      <div class="flex items-center mt-2  p-2"  >
        <div>
          <img src="@/assets/logo.png" class="lg:w-32  w-32" alt="">
        </div>
        <div>
          <h1 class="lg:text-2xl font-bold lg:ml-4 text-center">Prompt-o-tron</h1>
          <small class="lg:ml-8 text-gray-400 inline-block text-center text-sm font-thin">Take the throne of inspiration with <br/>Prompt'o'thron the Midjourney Prompt Helper</small>
        </div>
      </div>
      
    
    <code @click="copy()" class="bg-gray-800 text-white p-4 rounded mt-4 block cursor-pointer" >{{combinedText}}</code>
      <small class="mb-4 md:mt-3 md:mb-3 block text-gray-500 text-center">Click or Tab the Code block to Copy the Prompt </small>
    <div :class="showTextInput ? ' hidden md:block': 'block '">
      <input :placeholder="randomItem" class="p-2 border-2 w-full text-black ring-2 border-none rounded " v-model="promt_text" name="text"  />
      <small class="text-gray-400 block mt-2">Textprompt Weights</small>
      <vue-slider class="mt-3 mb-5 mx-4" v-model="text_weight" :min="0" :max="5" :interval="0.5" :marks="true" />
    </div>
    </div>
  </div>

  <!-- <div class="flex flex-col lg:flex-row justify-center lg:mx-0 mx-5 pt-5"> -->

  <div class="md:flex md:flex-row justify-center  grid grid-cols-2 gap-2 mx-4 md:mt-10 mt-5 block">
    <button class="btn block md:hidden " @click="showTextInput = !showTextInput">Text</button>
    <button class="btn" v-for="(v,i) in dataImages" :key="i" @click="ToogleModal(v.id)">{{ v.title }}</button>
  </div>

  <div class="flex flex-col lg:flex-row justify-center lg:mx-0 mx-5 pt-5">
    <div class="dropdown relative btn">
      <button class="bg-gray-200 hover:bg-gray-300 font-semibold  rounded inline-flex items-center mt-0">
        <span class="mr-1">Aspect Ratios</span>
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
      </button>
      <div class="dropdown-menu absolute text-left hidden pt-2 -ml-2 w-80">
        <div 
        class="" 
        v-for="(v,i) in ar" :key="i">
          <div :class="checkARSelection(v)" 
          @click="prompts.options.ar = v"
          v-if="v.allowed.includes(prompts.options.style.text)"
          v-text="v.text"
          class="bg-gray-200 select-none cursor-pointer hover:bg-gray-400 px-4 block whitespace-no-wrap">   
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown relative btn">
      <button class="bg-gray-200 hover:bg-gray-300 font-semibold rounded inline-flex items-center mt-0">
        <span class="mr-1">Style</span>
        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/> </svg>
      </button>
      <div class="dropdown-menu absolute text-left hidden pt-2 -ml-2 w-80">
        <div 
        class="" 
        v-for="(v,i) in style" :key="i">
          <div 
          :class="checkARStyle(v)" 
          @click="prompts.options.style = v"  
          v-if="styleIsAllowed(v)"
          class="bg-gray-200 select-none cursor-pointer hover:bg-gray-400 py-2 px-4 block whitespace-no-wrap">
          {{v.text}}
          </div>
        </div>
       
      </div>
    </div>
    <button class="btn btn-red" @click="Clear()">Clear</button>
  </div>


<div>
  

  <div v-show="hashTags != ''" class="mx-4">

    <h3 class="block mb-5">Instagram Hashtags</h3>
    <code class="bg-gray-200 p-3">
      {{ hashTags }}
    </code>
  </div>
</div>


  </div>
</template>

<script>
import VueSelectImage from './components/image-select.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'


export default {
  metaInfo: {
    title: 'Prompt-o-tron - The Midjourney Prompt Generator',

    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  name: 'App',
  components: {
    VueSelectImage,
    VueSlider
   },
  mounted() {
      this.getData()
    },
  computed: {
    randomItem() {
      let items = this.imagine.slice();
      let item = items.sort(() => Math.random() - 0.5)[0];
      return item;
    },
    hashTags(){
      let options = []
      let prefix = ''
      if(this.prompts.data.length >= 1){
        prefix = '#'
      }
      this.prompts.data.forEach(el => {
        options.push(el.command.replace('_','').replace(' ',''))
      });

      let pre = '';
      if(this.promt_text != ''){
        pre = '#'
      }

      return pre +`${this.promt_text.replace('::','').replace(' ',' #')}`+' '+prefix+options.join(' #');
    },

    combinedText() {
      let options = []
      let prefix = ''
      if(this.prompts.data.length >= 1){
        prefix = ':: '
      }
      this.prompts.data.forEach(el => {
        options.push(el.command + (el.weight > 1 ? '::'+el.weight:''))
      });

      let weight = '';
      if(this.text_weight > 0.1){
        weight = '::'+this.text_weight
      }

      let ar = '';
      if(this.prompts.options.ar.command != '--ar 1:1'){
        ar = this.prompts.options.ar.command
      }

      let style= '';
      if(this.prompts.options.style.command != '--style 4a' || this.styleIsAllowed(this.prompts.options.ar.command)){
        style = this.prompts.options.style.command
      }
      
     
      return '/imagine prompt:'+`${this.promt_text.trim()}${weight}`+prefix+options.join(', ')+ ar+' '+style;
    },
  },
  data(){

    return {
      totalCount: 0,
      currentSelectedCount:0,
      componentKey: 1,
      loading:true,
      showTextInput:true,
      showModal:false,
      imagine:[
        'A picturesque landscape with mountains and a lake in the foreground',
        'A bustling city street filled with cars and people',
        'A sunset-red skyline of a big city',
        'A peaceful scene on a meadow with sheep and a river',
        'A historic building with tall columns and a staircase',
        'A beach with palm trees and crystal-clear water',
        'A peaceful forest with a river and a lake',
        'A modern shopping mall filled with people and stores',
        'A spectacular waterfall surrounded by lush green foliage.'
      ],
      ar:[
        {
          text: '1:1 (Default)',
          command: '--ar 1:1',
          default: true,
          allowed:['4a', '4b','4c']
        },
        {
          text: '1:2 ',
          command: '--ar 1:2',
          default:false,
          allowed:['4a', '4b','4c']
        },
        {
          text: '2:1 ',
          command: '--ar 2:1',
          default:false,
          allowed:['4a', '4b','4c']
        },
        {
          text: '5:4 (Common frame and print)',
          command: '--ar 5:4',
          default:false,
          allowed:['4a']
        },
        {
          text: '4:5 (Common frame and print)',
          command: '--ar 4:5',
          default:false,
          allowed:['4a']
        },
        {
          text: '3:2 (Common in print photography)',
          command: '--ar 3:2',
          default:false,
          allowed:['4a']
        },
        {
          text: '2:3 (Common in print photography)',
          command: '--ar 2:3',
          default:false,
          allowed:['4a']
        },
        {
          text: '7:4 (Close to HD TV screens and smartphone screens)',
          command: '--ar 7:4',
          default:false,
          allowed:['4a']
        },
        {
          text: '4:7 (Close to HD TV screens and smartphone screens)',
          command: '--ar 4:7',
          default:false,
          allowed:['4a']
        }
       

      ],
      style:[
        {
          text: '4a',
          command: '--style 4a',
        },
        {
          text: '4b',
          command: '--style 4b'
        },
        {
          text: '4c',
          command: '--style 4c'
        }

      ],
      promt_text: '',
      text_weight: 0,
      ismultiple: true,
      prompts:{
        data:[],
        options:{
          'ar':   {
          text: '1:1 (Default)',
          command: '--ar 1:1',
          default: true,
          allowed:['4a', '4b','4c']
        },
          'style':{
          text: '4a',
          command: '--style 4a'
        }
        },       
      },
      modal:{
        title:'',
        dataset:[],
        count:0
      },
      initialSelected:[],
      dataImages: []
         
    }
  },
  methods:{
    copy(){

      navigator.clipboard.writeText(this.combinedText);      
      this.$toast.center('Copied');
    },
    async getData() {
        const res = await fetch("https://cabcom13.de/api/");
        const finalRes = await res.json();

        this.dataImages = finalRes
        this.loading = false
    },


    styleIsAllowed(v){

      return this.prompts.options.ar.allowed.includes(v.text);
      // let result = this.prompts.options.ar.find(user => user.allowed.includes(v.command));
      // if (result) {
      //   console.log(`A user who likes  was found in the array`);
      // } else {
      //   console.log(`A user who likes was not found in`);
      // }
    },
    checkARStyle(v){
        if(v.command == this.prompts.options.style.command ){
          return 'bg-gray-500 text-white'
        } else {
          if(this.prompts.options.style.command =='' && v.command==""){
            return 'bg-gray-500 text-white'
          } else {
            return ''
          }  
        }     
    },
    checkARSelection(v){
        if(v.command == this.prompts.options.ar.command ){
          return 'bg-gray-500 text-white'
        } else {
          if(this.prompts.options.ar.command =='' && v.command==""){
            return 'bg-gray-500 text-white'
          } else {
            return ''
          }  
        }     
    },
    isImageSelect(){
         if (Array.isArray(this.modal.dataset) && this.modal.dataset.length > 0 && typeof this.modal.dataset[0] === "object" && "src" in this.modal.dataset[0]) {
          if (!this.modal.dataset[0].src) {
             return true
            } else {
              return false
            }
        } 
    },
    Clear(){
      this.text_weight = 0
      this.promt_text = ''
      this.selected = []
      this.selected = []
      this.modal =  {
        title:'',
        dataset:[],
        count:0
      }
      this.prompts ={
          data:[],
          options:{
            'ar':   {
            text: '1:1 (Default)',
            command: '--ar 1:1',
            default: true,
            allowed:['4a', '4b','4c']
          },
            'style':{
            text: '4a',
            command: '--style 4a'
          }
        }    
      }


    },
    setOption(typ, value){
        this.prompts.options[typ] = value
        this.$modal.toggle('example')
    },
    setPrompts(){
      this.$modal.toggle('example')
    },
    clearModal(){
      this.modal.dataset.forEach(obj => {
        const index = this.prompts.data.findIndex(item => JSON.stringify(item) === JSON.stringify(obj));
        if (index !== -1) {
          // Objekt gefunden
   
          this.prompts.data.splice(index, 1);
        }
      });
      this.modal =  {
        title:'',
        dataset:[],
        count:0
      }
      this.showModal = !this.showModal
    },
    hideModal(){
      this.modal =  {
        title:'',
        dataset:[],
        count:0
      }
      this.showModal = !this.showModal
    },
    ToogleModal(val){

      this.componentKey += 1
      const object = this.dataImages.find(obj => obj.id === val);

      this.modal = {
        title:object.title,
        dataset: object.data,
        count:0
      }
      console.log(this.modal)
      // this.$modal.toggle('example')
      this.showModal = !this.showModal
    },
    sortArray(){
      this.prompts.data.sort((a, b) => {
        if (a.command.startsWith(" --") && !b.command.startsWith(" --")) {
          return 1;
        } else if (!a.command.startsWith(" --") && b.command.startsWith(" --")) {
          return -1;
        }
        return 0;
      });
    },
    onSelectImage(v){
      const tempPrompt = [...this.prompts.data];
      if (tempPrompt.find(item => item.id === v.id)) {
        this.prompt.push(tempPrompt.find(item => item.id === v.id));
      } else {
        this.prompt.push(v);
      }
    },
    onSelectMultipleImage(v) {
         if (!Array.isArray(v)) {
          v = [v];
        }
        const tempPrompt = [... this.prompts.data];
        this.prompts.data = [];
        v.forEach(element => {     
          if (tempPrompt.find(item => item.id === element.id)) {
            this.prompts.data.push(tempPrompt.find(item => item.id === element.id));
           
          } else {
            this.prompts.data.push(element);
            
          }
          
        });



        this.sortArray();
      }

  },

}
</script>

<style>
.loader {
  color: #ffffff;
  font-size: 20px;
  margin: 100px auto;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: load4 1.3s infinite linear;
  animation: load4 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
@-webkit-keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
@keyframes load4 {
  0%,
  100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}


</style>
